import * as React from "react";
import { GridItem, Text, VStack } from "@chakra-ui/react";

interface DescriptionProps {
  label: React.ReactNode;
  options: string[];
}

const Description: React.FC<DescriptionProps> = ({ label, options }) => (
  <GridItem
    as={VStack}
    spacing="8px"
    display="inline-flex"
    alignItems="flex-start"
  >
    <Text fontWeight="bold" color="gray.600">
      {label}
    </Text>
    <VStack spacing="4px" alignItems="flex-start">
      {options.map(opt => (
        <Text key={opt} color="gray.900" fontWeight="normal">
          {opt}
        </Text>
      ))}
    </VStack>
  </GridItem>
);

export default Description;
